import React from 'react'

export default function PhotoSpotsLoadMoreButton({ onClick }) {
  return (
    <div className="load-more-container text-center mt-4">
      <button onClick={onClick} className="btn-secondary inline-block">
        Load more
      </button>
    </div>
  )
}

